@let vState = state();
@let vDates = dates();

@if (vState && vDates) {
  <h2 class="heading-xl">RSVP to {{ tripTitle() }}</h2>
  <p class="body-copy-sm">
    @if (vDates.start === vDates.end) {
      The trip is set for the {{ vDates.start | date: "dd/MM/yyyy" }}.
    } @else {
      The trip is set for {{ vDates.start | date: "dd/MM/yyyy" }} to
      {{ vDates.end | date: "dd/MM/yyyy" }}.
    }
    <br />
    Are you in?
  </p>
  <form class="form" [formGroup]="rsvpForm">
    <div class="form-group">
      <div class="radio-button-group vertical">
        <label class="radio-button">
          <input
            type="radio"
            id="yes"
            name="status"
            value="Yes"
            formControlName="status" />
          <span>I'm in!</span>
        </label>
        <label class="radio-button">
          <input
            type="radio"
            id="maybe"
            name="status"
            value="Maybe"
            formControlName="status" />
          <span>There's a chance</span>
        </label>
        <label class="radio-button">
          <input
            type="radio"
            id="no"
            name="status"
            value="No"
            formControlName="status" />
          <span>Can't make it</span>
        </label>
      </div>
    </div>
    <hr>
    @if (!isOwner()) {
      <div class="form-group">
        <p>Send a message to the organizer if you need any help.</p>
        <at-form-field label="Message for organizer (optional)">
          <input type="text" name="msg" formControlName="message" />
        </at-form-field>
      </div>
    }
    <div class="actions">
      <button class="button tertiary" (click)="onReplyChange()">
        Decide later
      </button>
      <button class="button primary" (click)="rsvp.next('Yes')">Save response</button>
    </div>
  </form>
}
